import { Outlet, Navigate } from 'react-router-dom'
import { getTokenLocal } from '../../utils/Session';

const PrivateRoutes = () => {
    let auth = getTokenLocal();
    return(
        auth ? <Outlet/> : <Navigate to="/login"/>
    )
}

export default PrivateRoutes